module.exports = __webpack_public_path__ + "static/img/GYWM-23.3b9a4b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutUs/GYWM-23.jpg
// module id = i3zk
// module chunks = 1